import React from "react";
import { useTranslation } from "react-i18next";

export default function SettingsCard({
    label,
    description,
    logo,
    value = "",
    measureUnit = null,
    onChange,
    inputType = "text",
    placeholder = "",
    step = 1
}) {

    const [t] = useTranslation("global");

    const checkboxLabel = value ? t("setting.status.enabled") : t("setting.status.disabled");
    const inputId = `settings-card-${label.replace(/\s+/g, "-").toLowerCase()}`;

    return (
        <div className="card bg-dark text-white h-100 d-flex flex-column">
            <div className="card-body d-flex flex-column">
                <div className="row align-items-center">
                    {logo && (
                        <div className="col-auto text-muted">
                            <h2 className="mb-0">{logo}</h2>
                        </div>
                    )}

                    <div className="col">
                        <h5 className="card-title">{label}</h5>
                    </div>
                </div>

                <p className="card-text text-muted flex-grow-1 mt-2">{description}</p>

                <div className="row align-items-center mt-auto">
                    {inputType === "checkbox" ? (
                        <div className="col-auto">
                            <div className="form-check form-switch">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    role="switch"
                                    id={inputId}
                                    checked={Boolean(value)}
                                    onChange={onChange}
                                />
                                <label className="form-check-label ms-2" htmlFor={inputId}>
                                    {checkboxLabel}
                                </label>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="col-auto">
                                <input
                                    type={inputType}
                                    className="form-control"
                                    value={value}
                                    placeholder={placeholder}
                                    onChange={onChange}
                                    step={inputType === "number" ? step || "any" : undefined}
                                />
                            </div>
                            {measureUnit && (
                                <div className="col-auto text-muted">{measureUnit}</div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
